import { Model } from '@vuex-orm/core';
import moment from 'moment';
import { capitalize } from 'lodash-es';

/**
 * Client Sex
 */
export const SEX = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other'
};
export const SEX_NAME = {
  [SEX.MALE]: 'man',
  [SEX.FEMALE]: 'vrouw',
  [SEX.OTHER]: 'anders'
};
export const SEX_TITLE = {
  [SEX.MALE]: 'meneer',
  [SEX.FEMALE]: 'mevrouw',
  [SEX.OTHER]: ''
};

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class Client extends Model {
    static entity = 'clients'

    static primaryKey = 'id'

    static fields () {
      return {
        id: this.attr(null),
        name: this.string(null),
        date_of_birth: this.attr(null),
        city: this.string(null),
        about: this.string(null),
        motivation: this.string(null),
        call_frequency: this.string(null),
        last_call: this.attr(null),
        signed_up: this.attr(null),
        sticky: this.attr(null),
        reason: this.attr(null),
        sex: this.string(null)
      };
    }

    static async load (id) {
      return await Client.$get({ params: { id }});
    }

    /**
     * Get the appropriate title for the client
     */
    get title () {
      return SEX_TITLE[this.sex];
    }

    /**
     * Get the name for the client's sex
     */
    get sexName () {
      return SEX_NAME[this.sex];
    }

    /**
     * Get the age in years
     */
    get age () {
      return moment().diff(
        moment(this.date_of_birth, 'YYYY-MM-DD'),
        'years'
      );
    }

    get avatar () {
      const gender = this.sex === SEX.MALE ? 'man' : 'woman';
      return `/img/zilverlijn-avatars/avatar_${gender}.png`;
    }

    formatDate (date) {
      return moment(date, 'YYYY-MM-DD').format('D-M-YYYY');
    }

    capitalize (text) {
      return capitalize(text);
    }

    /**
     * Axios default overrides
     * @see {@link https://github.com/vuex-orm/plugin-axios/blob/master/README.md}
     */
    static methodConf = {
      http: {
        url: 'regicall/clients'
      },
      methods: {
      }
    }
}
